module.exports = __webpack_public_path__ + "static/econom-0dd2d9c49c17fc05034130a81d49a1c5.jpg";